var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5003 46.0005C59.9699 46.0005 59.4612 46.2112 59.0861 46.5863C58.711 46.9613 58.5003 47.4701 58.5003 48.0005V64.0005C58.5003 64.5309 58.711 65.0396 59.0861 65.4147C59.4612 65.7898 59.9699 66.0005 60.5003 66.0005C61.0308 66.0005 61.5395 65.7898 61.9145 65.4147C62.2896 65.0396 62.5003 64.5309 62.5003 64.0005V48.0005C62.5003 47.4701 62.2896 46.9613 61.9145 46.5863C61.5395 46.2112 61.0308 46.0005 60.5003 46.0005Z",
    fill: "#E8B606"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5003 72.0005C62.5003 70.8959 61.6049 70.0005 60.5003 70.0005C59.3957 70.0005 58.5003 70.8959 58.5003 72.0005C58.5003 73.1051 59.3957 74.0005 60.5003 74.0005C61.6049 74.0005 62.5003 73.1051 62.5003 72.0005Z",
    fill: "#E8B606"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 59.5,
    stroke: "#E8B606"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.d9c6c522c019db6fd9580c830683a076.svg";
export { ForwardRef as ReactComponent };